import React from 'react';
import S from './Wishlist.module.css';

const Wishlist = () => {
    return (
        <React.Fragment>
            <div className={S.teller}>

                <h1>Your Wishlisted Products</h1>

            </div>

            <div className={S.grid}>

            </div>
        </React.Fragment>
    )
}

export default Wishlist